import { Button, Col, Typography } from "antd";
import React from "react";
import { InputSelect } from "../../../../shared/components";
import { useCreateProduct3x2 } from "../../hooks";
import { useProducts } from "../../../products";
import { useParams } from "react-router-dom";

const { Text } = Typography;
export const Product3x2Form = ({
  setOpenModalCreate,
}: {
  setOpenModalCreate: (val: boolean) => void;
}) => {
  const { rule_id } = useParams();
  const { control, handleSubmit } = useCreateProduct3x2({
    setOpenModalCreate,
    rule_id: +rule_id!,
  });
  const { productsPremiun, findAllProductsPremium } = useProducts();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    findAllProductsPremium('false');
  }, []);
  
  return (
    <form onSubmit={handleSubmit}>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Selecciona un producto:</Text>
        <InputSelect
          label="Selecciona un producto"
          name="product_id"
          control={control}
          dataOptions={productsPremiun.map((item) => ({
            title: item.name,
            value: item.id.toString(),
          }))}
        />
      </Col>
      <Button
        htmlType="submit"
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
      >
        Crear
      </Button>
    </form>
  );
};
